import { createSelector } from 'reselect'

export const contextConfigSelector = createSelector(
  state => state.appConfig,
  appConfig => {return {patientDisplay: appConfig.patientDisplay, nurseDashboard: appConfig.nurseDashboard, adminDisplay: appConfig.adminDisplay}}
)